export const rootRoute = {
  path: '/',
  title: 'Home',
}

export const homeRoute = {
  path: '/home',
  title: 'Home',
}

export const locationRoute = {
  path: '/:locationId(\\d+)',
  title: 'Home',
}

export const selectLocationRoute = {
  path: '/select-location',
  title: 'Search for an address',
}
export const selectKioskRoute = {
  path: '/select-kiosk',
  title: 'Select your kiosk',
}

export const noLocationRoute = {
  path: '/no-location',
  title: 'Location Not Found',
}

export const loginRoute = {
  path: process.env.REACT_APP_LOGIN_URL,
  title: 'Login',
}

export const logoutRoute = {
  path: '/logout',
  title: 'Logout',
}

export const forgotPasswordRoute = {
  path: '/forgot-password',
  title: 'Forgot Password',
}

export const changePasswordRoute = {
  path: '/change-password/:token',
  title: 'Change Password',
}

export const unsubscribeRoute = {
  path: '/unsubscribe',
  title: 'Unsubscribe',
}

export const profileRoute = {
  path: '/profile',
  title: 'Profile',
}

export const historyRoute = {
  path: '/history',
  title: 'History',
}

export const creditsRoute = {
  path: '/credits',
  title: 'Credits',
}

// Used by mobile
export const termsAndConditionsRoute = {
  path: '/terms-and-conditions',
  title: 'Terms and Conditions',
}

export const termsAndConditionsRewardsRoute = {
  path: '/terms-and-conditions-rewards',
  title: 'Terms and Conditions - Rewards',
}

// Used by mobile
export const privacyPolicyRoute = {
  path: '/privacy',
  title: 'Privacy',
}

export const contactRoute = {
  path: '/contact',
  title: 'Contact',
}

export const placeOrderRoute = {
  path: '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/order',
  title: 'Place Order',
}

export const checkoutRoute = {
  path: '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/checkout',
  title: 'Checkout',
}

export const confirmationRoute = {
  path: '/confirmation/:orderId(\\d+)/:locationId(\\d+)',
  title: 'Confirmation',
}

export const maintenanceRoute = {
  path: '/maintenance',
  title: 'This page is under maintenance',
}

export const friendsRoute = {
  path: '/friends',
  title: 'Friends',
}

export const completeAccountRoute = {
  path: '/complete-account/:token',
  title: 'Complete Your Account',
}

export const slackRoute = {
  path: '/slack',
  title: 'Slack',
}

export const referralRoute = {
  path: '/referral',
  title: 'Referral',
}

export const subscriptionTermsAndConditionsRoute = {
  path: '/subscription-terms-and-conditions',
  title: 'Subscription Terms And Conditions',
}

export const referralTermsAndConditionsRoute = {
  path: '/referral-terms-and-conditions',
  title: 'Referral Terms And Conditions',
}

export const redeemGiftRoute = {
  path: '/gift/:giftCode',
  title: 'Redeem Gift',
}

export const uiRoute = {
  path: '/ui-components',
  title: 'UI Components',
}
